<script setup>
import ProgressSpinner from 'primevue/progressspinner';

const props = defineProps({
    isLoading: {
        type: Boolean,
        required: true
    },
    modal: {
        type: Boolean,
        default: false
    },
    modalBox: {
        type: Boolean,
        default: false
    },
    message: {
        type: String,
        default: 'Carregando...'
    },
    stroke: {
        type: String,
        default: '2'
    }
});
</script>

<template>
    <!-- MODAL -->
    <transition v-if="modal" name="modal">
        <div v-if="isLoading" class="modal-mask">
            <div class="modal-wrapper">
                <div :class="['loading-container', props.modalBox ? 'loading-box' : '']">
                    <div class="modal-container">
                        <ProgressSpinner :stroke-width="props.stroke" fill="transparent" />
                    </div>

                    <span :class="['loading-text', props.modalBox ? 'loading-box-text' : '']">
                        <slot>{{ message }}</slot>
                    </span>
                </div>
            </div>
        </div>
    </transition>

    <!-- INLINE -->
    <div v-else v-show="isLoading" class="inline-container">
        <ProgressSpinner :stroke-width="props.stroke" fill="transparent" />

        <span class="inline-text">
            <slot>{{ message }}</slot>
        </span>
    </div>
</template>

<style scoped>
:deep(.p-progressspinner-circle) {
    stroke: var(--color-primary) !important;
}

/* ================= MODAL ================= */
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    vertical-align: middle;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.loading-container {
    width: fit-content;
    height: fit-content;
    padding: 20px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
}

.loading-box {
    background: #ffffff;
}

.loading-box-text {
    color: #343434 !important;
}

.modal-container {
    width: 100px;
    margin: 0 auto;
    transition: all 0.3s ease;
}

.loading-text {
    margin-top: 1rem;
    font-size: 1.1rem;
    font-weight: 700;
    color: white;
    white-space: nowrap;
}

/* ================= INLINE ================= */
.inline-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
}

.inline-text {
    font-size: 0.95rem;
}
</style>
